import {
    GET_GROUP,
    SET_GROUP_SKELETON,
    SET_GROUP_LOADING,
    REMOVE_GROUP_LOADING,
    SET_GROUP_DROPDOWN,
    SET_GROUP_MODULE_NAME
} from "../types";

const initialState = {
    loading: false, // Initit loading state
    groupSkeleton: {},
    groupData: {},
    dropdowns: {},
    oldValue: "",
    group_module_name: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_GROUP_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_GROUP_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_GROUP:
            return {
                ...state,
                groupData: { ...payload }
            };
        case SET_GROUP_SKELETON:
            return {
                ...state,
                groupSkeleton: { ...payload }
            };

        case SET_GROUP_DROPDOWN:
            return {
                ...state,
                dropdowns: { ...payload }
            };

        case SET_GROUP_MODULE_NAME:
            return {
                ...state,
                group_module_name: payload
            };

        default:
            return state;
    }
}